export default class ServiceProvider {
    constructor(searchService) {
        this._documentService = searchService;
    }
    get documentService() {
        return this._documentService;
    }
}
